import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EncrdecrService } from '../Auth/encrdecr.service';   // Ensure this service is imported correctly

@Injectable({
  providedIn: 'root'
})
export class AdminLoginStateService {
  private ShowPanUcc: BehaviorSubject<boolean>;
  public SeePnUc: Observable<boolean>; // Expose this observable for other components to subscribe to
  private role: string;
  public Menu: BehaviorSubject<string>;
  public DisEnBtn: BehaviorSubject<boolean>;
  public Hndicn: BehaviorSubject<boolean>;

  constructor(private EncrdecrService: EncrdecrService) {
    // Initialize role from sessionStorage
    this.role = sessionStorage.getItem('5gE4QWzFXWKewRC');

    // Check if the role matches the decrypted value and set the initial value for the BehaviorSubject
    const decryptedRole = '0'// this.EncrdecrService.getDecr(this.role);

    this.ShowPanUcc = new BehaviorSubject<boolean>(decryptedRole === '0');  // true if decryptedRole is '0', else false
    this.Menu = new BehaviorSubject<string>((sessionStorage.getItem('dsfagzvxctwre')));
    this.DisEnBtn = new BehaviorSubject<boolean>(!!(sessionStorage.getItem('wertyuiop')));
    this.Hndicn = new BehaviorSubject<boolean>(!!(sessionStorage.getItem('asdfghjkl')));
    // Expose the observable so other components can subscribe to it
    this.SeePnUc = this.ShowPanUcc.asObservable();
  }

  // Method to change the ShowPanUcc value
  togglePanUcc(value: boolean): void {
    this.ShowPanUcc.next(value);
  }

  UpdateMenu(): void {
    this.Menu.next((sessionStorage.getItem('dsfagzvxctwre')));
  }
  EnableDisable(): void {
    this.DisEnBtn.next((!!sessionStorage.getItem('wertyuiop')));
  }
  HandIcon(): void {
    this.Hndicn.next((!!sessionStorage.getItem('asdfghjkl')));
  }
}
